import { useTranslation } from 'react-i18next'
import { Button } from '@/components/v2/ui/Button'

interface ChannelEditorDirtyBarProps {
  isDirty: boolean
  isSaving: boolean
  changeCount: number
  onSave: () => void
  onDiscard: () => void
}

export function ChannelEditorDirtyBar({
  isDirty,
  isSaving,
  changeCount,
  onSave,
  onDiscard,
}: ChannelEditorDirtyBarProps) {
  const { t } = useTranslation()
  if (!isDirty) return null

  return (
    <div
      role="region"
      aria-label={t('productContent.channels.dirty.unsavedCount', { count: changeCount })}
      className="sticky bottom-0 inset-x-0 z-20 flex items-center justify-between gap-3 px-4 py-2.5 border-t border-amber-300 dark:border-amber-700 bg-amber-50/95 dark:bg-amber-950/70 backdrop-blur"
    >
      <div className="flex items-center gap-2 text-sm text-amber-900 dark:text-amber-100">
        <span className="w-2 h-2 rounded-full bg-amber-500" aria-hidden />
        <span>{t('productContent.channels.dirty.unsavedCount', { count: changeCount })}</span>
      </div>
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="sm" onClick={onDiscard} disabled={isSaving}>
          {t('productContent.channels.dirty.discard')}
        </Button>
        <Button variant="primary" size="sm" onClick={onSave} loading={isSaving}>
          {isSaving
            ? t('productContent.channels.dirty.saving')
            : t('productContent.channels.dirty.save')}
        </Button>
      </div>
    </div>
  )
}
